import { __assign } from "tslib";
import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import Loader from '../Loader';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';
import variables from '@wix/da-ds/src/styles/variables.scss';
var siteHeaderHeight = parseInt(variables['site-header-height'], 10);
var Drawer = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "notifications_shared" */
        './index');
    });
});
export var DrawerLoadable = function (props) {
    return (React.createElement(ErrorBoundary, { debugComponent: "DrawerLoadable" },
        React.createElement(AbsoluteHeightLayout, { heightReduction: siteHeaderHeight },
            React.createElement(Suspense, { fallback: React.createElement(Loader, { type: "drawer-suspense" }) },
                React.createElement(ModuleLoaderLazy, null),
                React.createElement(Drawer, __assign({}, props))))));
};
DrawerLoadable.displayName = 'DrawerLoadable';
export default DrawerLoadable;
//# sourceMappingURL=DrawerLoadable.js.map